import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgAutoGarage = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      d="M32 8H8v24h24z"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M33 8v24h-2V8zM9 8v24H7V8z"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M7 15h26v2H7zM7 11h26v2H7zM7 7h26v2H7zM28 26H12l2.15-4.83A1.8 1.8 0 0 1 15.73 20h8.54a1.8 1.8 0 0 1 1.58 1.17z"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      d="M28.9 26H11.1a1.1 1.1 0 0 0-1.1 1.1v3.8a1.1 1.1 0 0 0 1.1 1.1h17.8a1.1 1.1 0 0 0 1.1-1.1v-3.8a1.1 1.1 0 0 0-1.1-1.1"
    />
    <path
      fill="#F170B8"
      d="M16 30a2 2 0 1 0-4 0v2a2 2 0 1 0 4 0zM28 30a2 2 0 1 0-4 0v2a2 2 0 1 0 4 0z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M26.47 26H13.53l1.74-4a1.45 1.45 0 0 1 1.28-1h6.9a1.45 1.45 0 0 1 1.28 1z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M14 30.83a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M26 30.83a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M30.25 10.98v9.13h-1v-9.13zM12.927 21.74h4.493v1h-4.465a1.3 1.3 0 0 0-1.136.844l-.006.014-.266.604-.915-.404.255-.577a2.3 2.3 0 0 1 2.026-1.48z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgAutoGarage);

export default ForwardRef;
